import Utilities from '@/lib/Utilities'

export default {
  TextArea: {
    label: 'Text',
    key: Utilities.key(),
    type: 'TextArea',
    options: {
      data: {
        blocks: [
          {
            type: 'header',
            data: {
              text: 'Start typing!',
              level: 2
            }
          },
          {
            type: 'paragraph',
            data: {
              text: 'This is some sample content. You can edit this, or add new elements.'
            }
          }
        ]
      }
    }
  },
  ImageBlock: { label: 'Image', type: 'ImageBlock', options: { src: null, key: Utilities.key() } },
  DoughnutChart: {
    label: 'Pie Chart',
    type: 'Chart',
    options: {
      key: Utilities.key(),
      chartData: {
        labels: ['Option 1', 'Option 2', 'Option 3'],
        datasets: [{
          label: '# of Votes',
          data: [10, 20, 30],
          borderColor: '#ffffff',
          backgroundColor: [
            '#AF5D00',
            '#AF8600',
            '#fec300'
          ]
        }]
      },
      chartOptions: {
        cutoutPercentage: 50,
        legend: { display: true }
      },
      chartType: 'DoughnutChart'
    }
  },
  BarChart: {
    label: 'Bar Chart',
    type: 'Chart',
    options: {
      key: Utilities.key(),
      chartData: {
        labels: ['Option 1', 'Option 2', 'Option 3'],
        datasets: [{
          label: '# of Votes',
          data: [10, 20, 30],
          backgroundColor: [
            '#AF5D00',
            '#AF8600',
            '#fec300'
          ]
        }]
      },
      chartOptions: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              min: 0
            }
          }]
        }
      },
      chartType: 'BarChart'
    }
  },
  LineChart: {
    label: 'Line Chart',
    type: 'Chart',
    options: {
      key: Utilities.key(),
      chartData: {
        labels: ['Option 1', 'Option 2', 'Option 3'],
        datasets: [{
          label: '# of Votes',
          data: [-10, 15, 55],
          tension: 0.2,
          fill: false,
          backgroundColor: '#fec300',
          borderColor: '#1391DF',
          borderDash: []
        }]
      },
      chartType: 'LineChart',
      chartOptions: {
      }
    }
  }
}
